import { of as observableOf, Observable } from "rxjs";

const Escritorios = [
  { cnpj: "10176460000129", logo: "MAC" },
  { cnpj: "04595055000142", logo: "TS-COBRA" },
  { cnpj: "81924765000177", logo: "TS-COBRA" },
  { cnpj: "01029445000167", logo: "TS-COBRA" },
  { cnpj: "04271719000118", logo: "FERRAZ" },
  { cnpj: "02992780000129", logo: "JMS" },
  { cnpj: "09420301000149", logo: "BORGES" },
  { cnpj: "01288619000106", logo: "MORAIS" },
  { cnpj: "07045936000188", logo: "MORAIS" },
  { cnpj: "03451345000150", logo: "SAMUEL" },
  { cnpj: "03451345000156", logo: "SAMUEL" },
  { cnpj: "03451345000250", logo: "SAMUEL" },
  { cnpj: "03451345000350", logo: "SAMUEL" },
  { cnpj: "03451345000550", logo: "SAMUEL" },
  { cnpj: "03451345000650", logo: "SAMUEL" },
  { cnpj: "0345134500157", logo: "SAMUEL" },
  { cnpj: "0345134500163", logo: "SAMUEL" },
  { cnpj: "0351345000155", logo: "SAMUEL" },
  { cnpj: "03513450005555", logo: "SAMUEL" },
  { cnpj: "035135000157", logo: "SAMUEL" },
  { cnpj: "04678993000106", logo: "STOCCO" },
  { cnpj: "10176460000229", logo: "MAC" },
  { cnpj: "10176460000329", logo: "MAC" },
  { cnpj: "10176460000429", logo: "MAC" },
  { cnpj: "101764600005", logo: "MAC" },
  { cnpj: "10176460000629", logo: "MAC" },
  { cnpj: "200000000002", logo: "MAC" },
  { cnpj: "0000000004", logo: "MAC" },
  { cnpj: "0000000002", logo: "MAC" },
  { cnpj: "0000000001", logo: "MAC" },
  { cnpj: "10176460000829", logo: "MAC" },
  { cnpj: "10176460000929", logo: "MAC" },
  { cnpj: "10176460001129", logo: "MAC" },
  { cnpj: "10176460001029", logo: "MAC" },
  { cnpj: "200000000002", logo: "MAC" },
  { cnpj: "200000000003", logo: "MAC" },
  { cnpj: "200000000004", logo: "MAC" },
  { cnpj: "200000000005", logo: "MAC" },
  { cnpj: "200000000006", logo: "MAC" },
  { cnpj: "04271719000170", logo: "FERRAZ" },
  { cnpj: "04271719000370", logo: "FERRAZ" },
  { cnpj: "04271719000460", logo: "FERRAZ" },
  { cnpj: "042717190005", logo: "FERRAZ" },
  { cnpj: "042717190006", logo: "FERRAZ" },
  { cnpj: "042717190007", logo: "FERRAZ" },
  { cnpj: "0427171900207", logo: "FERRAZ" },
  { cnpj: "0000000000", logo: "CRESPO" },
  { cnpj: "00000000000001", logo: "CRESPO" },
  { cnpj: "00000000000002", logo: "CRESPO" },
  { cnpj: "00000000000003", logo: "CRESPO" },
  { cnpj: "02845894000146", logo: "CRESPO" },
  { cnpj: "02845894000227", logo: "CRESPO" },
  { cnpj: "02845894000300", logo: "CRESPO" },
  { cnpj: "02845894000499", logo: "CRESPO" },
  { cnpj: "02845894000570", logo: "CRESPO" },
  { cnpj: "02845894000600", logo: "CRESPO" },
  { cnpj: "52841178000169", logo: "PEREZ" },
  { cnpj: "19329005000190", logo: "Camargo" },
];

export const Logo = function (logoImagemCompany) {
  let logo: any;
  findLogoByCnpj(logoImagemCompany).subscribe((res) => (logo = res));
  return logo;
};

function findLogoByCnpj(cnpj: string): Observable<any> {
  const result = Escritorios.find((obj) => obj.cnpj === cnpj.toString());

  const logoNotFound = {
    cnpj: undefined,
    logo: "no-img",
  };

  const path = "assets/images/escritorios/";
  const img =
    path +
    (typeof result != "undefined" && result.logo
      ? result.logo + ".png"
      : logoNotFound.logo + ".png");

  return observableOf(img);
}
